import Nav from '@components/Nav/Nav'
import { Link } from 'react-router'

import logo from '@static/vectors/logo-datalab-dark.svg'
import './Header.css'

export default function Header() {
  return (
    <header id="masthead">
      <div className="container">
        <Link className="logo" to="/">
          <img src={logo} alt="dataLab logo" />
        </Link>
        <Nav />
      </div>
    </header>
  )
}
